import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { deleteIcon, errorIcon } from '../../../../assets/images';
import { polyglot } from '../../../../assets/locales';
import { formatter } from '../../../../utility';
import { CPIConstants, NormalizationConstants } from '../../../../constants';
import { InputBase } from '../../../Helper/InputBase';
import validate from '../../../../utility/validate';

class Improvement extends Component {
  constructor(props) {
    super();

    this.state = {
      title: '',
      cost: '',
      units: '',
      calculatedAmount: '',
      submitDisabled: false,
      checked: false,
      buttonText: 'Submit',
      errors: {},
    };
  }

  //set state to props if props are available (e.g going from page 2 -> page 1)
  componentDidMount() {
    const { improvement } = this.props;
    if (improvement) {
      this.setState({
        title: improvement.title,
        cost: improvement.cost,
        units: improvement.units,
        calculatedAmount: improvement.calculatedAmount,
        submitDisabled: improvement.submitDisabled ? improvement.submitDisabled : false,
        checked: improvement.checked ? improvement.checked : false,
      });
    }
  }

  //change handler. If cost > maxUpgradeSpent or units > maxUnits, input will not be accepted.
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '' },
    });
    if (this.state.submitDisabled)
      this.setState({
        submitDisabled: false,
        buttonText: 'Update',
        calculatedAmount: '',
      });
  };

  /*
   * Checks for errors once user clicks submit, and calculates the eligibleAmount.
   * submit() is also called on each improvement once "Continue" button is pressed.
   * calls Step1 updateImprovements function with improvement object.
   */
  submit = (e) => {
    const { title, cost, units, submitDisabled, buttonText, checked } = this.state;
    const { updateImprovement, id, continueClicked } = this.props;
    let calculatedAmount = '',
      submit = false;

    const validationArray = [
      {
        title: title,
        validationRules: [
          { minLength: 2, errorMsg: polyglot.t('errors.title.length') },
          { isRequired: true, errorMsg: polyglot.t('errors.title.empty') },
        ],
      },
      {
        cost: cost,
        validationRules: [
          { minValue: 1, errorMsg: polyglot.t('errors.cost.length') },
          { isRequired: true, errorMsg: polyglot.t('errors.cost.empty') },
        ],
      },
      {
        units: units,
        validationRules: [
          { minValue: 1, errorMsg: polyglot.t('errors.units.length') },
          { isRequired: true, errorMsg: polyglot.t('errors.units.empty') },
        ],
      },
    ];

    let err = validate(validationArray);

    if (continueClicked && !submitDisabled)
      err = {
        ...err,
        submit: `Press ${buttonText.toLocaleLowerCase()} to calculate`,
      };
    if (err.title || err.cost || err.units || err.submit) {
      this.setState({ errors: err });
    } else {
      submit = true;
      calculatedAmount = cost / CPIConstants.eligibleAmountDivider / units;
      this.setState({ submitDisabled: true, calculatedAmount, errors: err });
    }

    const updateObject = {
      id,
      title,
      cost,
      units,
      calculatedAmount,
      errors: err,
      submitDisabled: submit,
      checked,
    };

    updateImprovement(id, updateObject);
  };

  //check to see if continue button has been clicked in parent component
  componentDidUpdate(prevProps) {
    if (this.props.continueClicked && !prevProps.continueClicked) {
      this.submit();
    }
  }

  render() {
    const { title, cost, units, calculatedAmount, submitDisabled, buttonText, errors } = this.state;
    const { index, id, length, deleteImprovement } = this.props;

    return (
      <div className="improvement">
        <div className="improvement-title">
          <span>
            Capital Expenditure {index < 9 ? '0' : ''}
            {index + 1}
          </span>
          {length > 1 ? <img className="improvement-title-delete" onClick={() => deleteImprovement(id)} src={deleteIcon} alt="" /> : null}
        </div>
        <div className="improvement-inputs">
          <InputBase
            cssClass="improvement-inputs-title"
            errors={errors.title}
            value={title}
            name="title"
            type="text"
            label={polyglot.t('step1.improvements.title')}
            maxLength={NormalizationConstants.maxTitleLength}
            handleChange={this.handleChange}
          />
        </div>
        <div className="improvement-inputs">
          <InputBase
            cssClass="improvement-inputs-cost"
            errors={errors.cost}
            value={cost}
            maxLength={NormalizationConstants.maxUpgradeSpent}
            name="cost"
            type="number"
            label={polyglot.t('step1.improvements.cost')}
            startAdornment="$"
            handleChange={this.handleChange}
          />
        </div>
        <div className="improvement-inputs">
          <InputBase
            cssClass="improvement-inputs-units"
            errors={errors.units}
            value={units}
            maxLength={NormalizationConstants.maxUnits}
            size="md"
            name="units"
            type="number"
            label={polyglot.t('step1.improvements.units')}
            handleChange={this.handleChange}
          />
        </div>
        <div className="improvement-submit">
          <div className="improvement-submit-wrapper">
            <Button variant="success" className="improvement-submit-button" type="submit" disabled={submitDisabled} onClick={this.submit}>
              {buttonText}
            </Button>
            <FormControl disabled className="improvement-submit-result" name="calculatedAmount" type="text" value={calculatedAmount ? formatter.toAmountDisplay(calculatedAmount) : '$'} />
            <span>{polyglot.t('step1.improvements.eligibleAmount')}</span>
          </div>
          <label className="improvement-wrapper-error">
            {errors.submit ? <img className="improvement-wrapper-error-icon" src={errorIcon} alt="" /> : null}
            {errors.submit}
          </label>
        </div>
      </div>
    );
  }
}

export default Improvement;

Improvement.propTypes = {
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  improvement: PropTypes.object.isRequired,
  deleteImprovement: PropTypes.func.isRequired,
  updateImprovement: PropTypes.func.isRequired,
  continueClicked: PropTypes.bool.isRequired,
};